module.exports = __webpack_public_path__ + "static/media/spinning-loading.b213dc57.gif";